//Imports
import React from "react";
import { useParams } from "react-router-dom";
import Select, { components } from 'react-select';
//Imports data
import staticData from '../../../contexts/staticData.json';
//Imports Icons
import downArrow from '../../../assets/icons/downArrow.svg';
import add from '../../../assets/icons/add.svg';

function FormEditEstablishment({ selectRegionEstablishment, setSelectRegionEstablishment, establishments, setEstablishments }) {
    const { id } = useParams();

    // Function to handle changes in establishment-level Select components
    const handleEstablishmentSelectChange = (selectedOption, { name }, index) => {
        setEstablishments(prevEstablishments => {
            return prevEstablishments.map((establishment, i) => {
                if (i === index) {
                    if (name === 'region') {
                        setSelectRegionEstablishment(selectedOption.value)
                        return {
                            ...establishment,
                            region: selectedOption.value,
                            commune: '',
                        };
                    } else {
                        return {
                            ...establishment,
                            [name]: selectedOption.value,
                        };
                    }
                } else {
                    return establishment;
                }
            });
        });
    };

    const handleEstablishmentInputChange = (index, e) => {
        const { name, value } = e.target;
        setEstablishments(prevEstablishments => {
            return prevEstablishments.map((establishment, i) => {
                if (i === index) {
                    return {
                        ...establishment,
                        [name]: value,
                    };
                } else {
                    return establishment;
                }
            });
        });
    };

    const addEstablishment = () => {
        setEstablishments([...establishments, { rbd: '', name: '', region: '', commune: '', type: '' }]);
    };

    // Ordenar las regiones alfabéticamente
    const sortedRegions = [...staticData.regiones].sort((a, b) => 
        a.name.localeCompare(b.name, 'es', { sensitivity: 'base' })
    );

    // Ordenar los tipos de establecimiento alfabéticamente
    const sortedEstablishmentTypes = [...staticData.typeOfEstablishment].sort((a, b) => 
        a.localeCompare(b, 'es', { sensitivity: 'base' })
    );
     // Obtener las comunas ordenadas alfabéticamente si hay una región seleccionada
     const regionDataEstablishment = staticData.regiones.find((region) => region.name === selectRegionEstablishment);
     const sortedCommunes = regionDataEstablishment ? 
         [...regionDataEstablishment.communes].sort((a, b) => 
             a.name.localeCompare(b.name, 'es', { sensitivity: 'base' })
         ) : 
         [];
    return (
        <>
            <article className='third-box flex'>
                <p>Establecimientos</p>
                <button type='button' className='button-add-establishment flex' onClick={addEstablishment} >
                    <img src={add} className='icon' alt='Icono agregar establecimiento' />
                    <p>Agregar otro establecimiento</p>
                </button>
                <section className='table-container flex'>
                    <table className='table-establishment'>
                        <thead>
                            <tr>
                                <th>RBD</th>
                                <th>Nombre establecimiento</th>
                                <th>Región</th>
                                <th>Comuna</th>
                                <th>Tipo de Establecimiento</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                establishments.length === 0 ? (
                                    <tr>
                                        <td colSpan='8'>No existen proyectos</td>
                                    </tr>
                                ) : (establishments.map((establishment, index) => (
                                    <tr key={index}>
                                        <td>
                                            <input
                                                name='rbd'
                                                type='text'
                                                className='input'
                                                placeholder='Ingresar RBD'
                                                value={establishment.rbd}
                                                onChange={(e) => handleEstablishmentInputChange(index, e)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                name='nameEstablishment'
                                                type='text'
                                                className='input'
                                                placeholder='Ingresar nombre'
                                                value={establishment.nameEstablishment}
                                                onChange={(e) => handleEstablishmentInputChange(index, e)}
                                            />
                                        </td>
                                        <td>
                                            <Select
                                                name='region'
                                                id='region'
                                                options={sortedRegions.map((region) => ({
                                                    value: region.name,
                                                    label: region.name
                                                }))}
                                                onChange={(selectedOption, { name }) => handleEstablishmentSelectChange(selectedOption, { name }, index)}
                                                value={establishment.region}
                                                placeholder={establishment.region ? establishment.region : 'Selecciona una opción'}
                                                className='custom-select'
                                                classNamePrefix='custom-select'
                                                components={{ DropdownIndicator }}
                                                menuPortalTarget={document.body}  // Agregar menú al body
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),  // Asegurar que esté por encima de otros elementos
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        position: 'absolute',
                                                        top: '100%',  // Para que esté debajo del select,
                                                        width: '16rem',  // Ajustar el ancho,
                                                    }),
                                                    menuList: (provided) => ({
                                                        ...provided,
                                                        maxHeight: '6.5rem',
                                                        overflowY: 'auto'
                                                    }),
                                                    control: (provided) => ({
                                                        ...provided,
                                                        marginBottom: '0'
                                                    }),
                                                }}
                                            />
                                        </td>
                                        <td>
                                            <Select
                                                name='commune'
                                                id='commune'
                                                options={sortedCommunes.map((commune) => ({
                                                    value: commune.name,
                                                    label: commune.name
                                                }))}
                                                onChange={(selectedOption, { name }) => handleEstablishmentSelectChange(selectedOption, { name }, index)}
                                                value={establishment.commune}
                                                placeholder={establishment.commune ? establishment.commune : 'Selecciona una opción'}
                                                className='custom-select'
                                                classNamePrefix='custom-select'
                                                components={{ DropdownIndicator }}
                                                menuPortalTarget={document.body}  // Agregar menú al body
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),  // Asegurar que esté por encima de otros elementos
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        position: 'absolute',
                                                        top: '100%',  // Para que esté debajo del select,
                                                        width: '16rem',  // Ajustar el ancho,
                                                    }),
                                                    menuList: (provided) => ({
                                                        ...provided,
                                                        maxHeight: '6.5rem',
                                                        overflowY: 'auto'
                                                    }),
                                                    control: (provided) => ({
                                                        ...provided,
                                                        marginBottom: '0'
                                                    }),
                                                }}
                                            />
                                        </td>
                                        <td>
                                            <Select
                                                name='typeEstablishment'
                                                id='typeEstablishment'
                                                options={staticData.typeOfEstablishment.map((type) => ({
                                                    value: type,
                                                    label: type
                                                }))}
                                                onChange={(selectedOption, { name }) => handleEstablishmentSelectChange(selectedOption, { name }, index)}
                                                value={establishment.typeEstablishment}
                                                placeholder={establishment.typeEstablishment ? establishment.typeEstablishment : 'Selecciona una opción'}
                                                className='custom-select'
                                                classNamePrefix='custom-select'
                                                components={{ DropdownIndicator }}
                                                menuPortalTarget={document.body}  // Agregar menú al body
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),  // Asegurar que esté por encima de otros elementos
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        position: 'absolute',
                                                        top: '100%',  // Para que esté debajo del select,
                                                        width: '16rem',  // Ajustar el ancho,
                                                    }),
                                                    menuList: (provided) => ({
                                                        ...provided,
                                                        maxHeight: '6.5rem',
                                                        overflowY: 'auto'
                                                    }),
                                                    control: (provided) => ({
                                                        ...provided,
                                                        marginBottom: '0'
                                                    }),
                                                }}
                                            />
                                        </td>
                                    </tr>
                                ))
                                )}
                        </tbody>
                    </table>
                </section>
            </article>
        </>
    )
}

const DropdownIndicator = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            <img src={downArrow} alt="CustomArrow" />
        </components.DropdownIndicator>
    );
};

export default FormEditEstablishment;